import { MoreVertical, X } from "react-feather";
import { ActionMenu } from "@/Components/ActionMenu";
import React, { useEffect, useRef, useState } from "react";
import { Inertia } from "@inertiajs/inertia";
import { InertiaLink } from "@inertiajs/inertia-react";
import { toast } from "react-toastify";
import { Budget as BudgetIcon } from "@/Icons";

const Row = ({ tag }) => {
  let actionMenuItems;

  if (tag.is_global) {
    actionMenuItems = [
      {
        label: "View category",
        callback: () => Inertia.visit(`/categories/edit/${tag.id}`),
      },
    ];
  } else {
    actionMenuItems = [
      {
        label: "Edit category",
        callback: () => Inertia.visit(`/categories/edit/${tag.id}`),
      },
      {
        label: "Delete category",
        callback: () =>
          openModal(
            "Are you sure?",
            `You're about to remove ${tag.name}`,
            `Do you want to continue?`,
          ),
      },
    ];
  }

  const actionMenuRef = useRef(null);

  let [modal, setModal] = useState({
    open: false,
    title: "",
    content: "",
    class: "",
  });
  useEffect(() => {
    return () => {
      if (modal.open) {
        closeModal();
      }
    };
  });

  const [animationClass, setAnimationClass] = useState("");

  function openModal(l, t, d, c) {
    setAnimationClass("modal-slide-in");
    setModal({ open: true, label: l, title: t, content: d, class: c });
  }

  function closeModal() {
    setAnimationClass("modal-slide-out");
    setTimeout(() => {
      setModal({ open: false, label: "", title: "", content: "", class: "" });
    }, 300);
  }

  const handleDelete = () => {
    const id = toast.loading("Please wait...");
    Inertia.delete(`/categories/${tag.id}`, {
      onSuccess: () => {
        toast.update(id, {
          render: `Your category was successfully deleted`,
          type: "success",
          isLoading: false,
          autoClose: 5000,
        });
      },
      onError: (error) => {
        toast.update(id, {
          render: `Something went wrong when deleting your category`,
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });
      },
    });
  };

  return (
    <>
      <InertiaLink
        href={`/categories/edit/${tag.id}`}
        className="shadow-small grid min-h-[53px] cursor-pointer grid-cols-4 gap-2 bg-gray-light p-4 md:grid-flow-col-dense md:grid-cols-12 md:p-8 md:px-4 md:py-2"
      >
        <div className="col-span-3 flex items-center md:col-span-11">
          {tag?.budget === 1 && (
            <BudgetIcon
              className="mr-2"
              title="Category is included in budget"
            />
          )}
          <h3 className="truncate font-bold leading-none">{tag.name}</h3>
          {tag.questions && (
            <div className="ml-4 flex items-center">
              {tag.questions.length}{" "}
              {tag.questions.length === 1 ? "activity" : "activities"}
            </div>
          )}
        </div>
        <div className="col-span-1 flex items-center justify-end md:order-last md:col-span-1">
          <div className="hover-circle relative z-10 ml-2">
            <MoreVertical
              size={24}
              className="shrink-0 cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                actionMenuRef.current.toggleMenu();
              }}
            />
            <ActionMenu ref={actionMenuRef} items={actionMenuItems} />
          </div>
        </div>
      </InertiaLink>

      {modal.open && (
        <div className="fixed left-0 top-0 z-10 flex h-full w-full flex-col justify-center bg-black bg-opacity-50 lg:pl-[240px] 4xl:pl-[300px]">
          <div
            className="absolute left-0 top-0 h-full w-full"
            onClick={closeModal}
          />
          <div className="px-4 lg:px-16 4xl:pl-32">
            <div className="mx-auto 4xl:mx-0 4xl:max-w-screen-3xl ">
              <div
                className={`relative mx-auto w-full max-w-2xl bg-white p-8 align-middle md:p-16 ${animationClass}`}
              >
                <div className="mb-2.5 flex items-center justify-between">
                  <span className="rounded-br-2xl bg-apricot px-4 py-2 text-white">
                    {modal.label}
                  </span>
                  <X
                    className="h-12 w-12 cursor-pointer p-2"
                    onClick={closeModal}
                  />
                </div>
                <h3 className="mb-3 text-xl font-semibold">{modal.title}</h3>
                <p>{modal.content}</p>

                <div className="mt-5 flex w-full justify-end border-t pt-8">
                  <a
                    className="cursor-pointer py-4 text-blue underline"
                    onClick={closeModal}
                  >
                    Never mind
                  </a>

                  <button className="btn ml-3 self-end" onClick={handleDelete}>
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Row;
